import { ProjectStatus } from '../../common/project-status';
import { IAppliedDiscount, AppliedDiscount } from '../../common/applied-discount';
import { IInstallationSiteModel, InstallationSiteModel } from './installation-site-model';
import { IPaymentTransactionModel, PaymentTransactionModel } from './payment-transaction-model';

export interface ICustomerInvoiceModel {
    projectStatus: ProjectStatus;
    customerName: string;
    addressLineI: string;
    addressLineIi: string;
    retailSubtotal: number;
    subtotal: number;
    discounts: IAppliedDiscount[];
    tax: number;
    total: number;
    installLocations: IInstallationSiteModel[];
    installationScheduled: number;
    installationDate: number;
    paymentTransactions: IPaymentTransactionModel[];
}


export class CustomerInvoiceModel implements ICustomerInvoiceModel {
    public projectStatus: ProjectStatus = ProjectStatus.Indeterminate;
    public customerName: string = '';
    public addressLineI: string = '';
    public addressLineIi: string = '';
    public retailSubtotal: number = 0;
    public subtotal: number = 0;
    public discounts: IAppliedDiscount[] = [];
    public tax: number = 0;
    public total: number = 0;
    public installLocations: IInstallationSiteModel[] = [];
    public installationScheduled: number = 0;
    public installationDate: number = 0;
    public paymentTransactions: IPaymentTransactionModel[] = [];
}


